import React from 'react';
import { Button } from '@/components/ui/button';
import { ChevronLeft, ChevronRight, Send } from 'lucide-react';
import { useTaxForm } from './TaxFormContext';

export const NavigationButtons: React.FC = () => {
  const {
    nextStep,
    prevStep,
    isFirstStep,
    isLastStep,
    saveDraft,
    isSaving,
    handleSubmit
  } = useTaxForm();

  const handleNext = async () => {
    await saveDraft();
    nextStep();
  };

  const handlePrev = async () => {
    await saveDraft();
    prevStep();
  };

  return (
    <div className="flex justify-between items-center mt-8 pt-6 border-t">
      <div className="flex items-center gap-4">
        {!isFirstStep && (
          <Button
            variant="outline"
            onClick={handlePrev}
            disabled={isSaving}
            className="flex items-center gap-2 hover:scale-105 transition-all duration-200"
          >
            <ChevronLeft className="h-4 w-4" />
            Previous
            <span className="font-urdu">/ پچھلا</span>
          </Button>
        )}
      </div>

      <div className="flex items-center gap-4">
        {!isLastStep ? (
          <Button
            onClick={handleNext}
            disabled={isSaving}
            className="flex items-center gap-2 hover:scale-105 transition-all duration-200 bg-gradient-to-r from-primary to-primary/80"
          >
            {isSaving ? 'Saving...' : 'Next'}
            <span className="font-urdu">/ اگلا</span>
            <ChevronRight className="h-4 w-4" />
          </Button>
        ) : (
          <Button
            onClick={handleSubmit}
            disabled={isSaving}
            className="flex items-center gap-2 hover:scale-105 transition-all duration-200 bg-gradient-to-r from-green-600 to-green-700"
          >
            <Send className="h-4 w-4" />
            Submit
            <span className="font-urdu">/ جمع کریں</span>
          </Button>
        )}
      </div>
    </div>
  );
};
